import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ConfirmationModal, MenuItem, Select, TextField } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useRestfulWrapper } from '~/hooks/useRestfulWrapper';
import { useUpdateRelationship } from '~/hooks/useUpdateRelationship';
import { useLocaleKeys } from '~/i18n';
import { agreementChangeModel, relationshipModel } from '~/models';
function AssigneeField(props) {
    const { members, sellerUserId, setSellerUserId } = props;
    const { t: changeAssigneeModalTexts } = useLocaleKeys('pages.agreementsDashboard.changeAssigneeModal');
    const options = useMemo(()=>members.filter((m)=>m.isAssignable(true)).map((m)=>({
                value: m.id(),
                label: m.fullName()
            })), [
        members
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        bi: {
            name: 'change_assignee'
        },
        collapseHelperText: false,
        testId: "select-assignee",
        label: changeAssigneeModalTexts.assigneeLabel(),
        value: sellerUserId,
        menuMaxHeight: 400,
        onChange: (e)=>setSellerUserId(e.target.value),
        children: options.map((param)=>{
            let { value, label } = param;
            return /*#__PURE__*/ _jsx(MenuItem, {
                value: value,
                testId: "select-assignee-option-".concat(value),
                children: label
            }, value);
        })
    });
}
export default function ChangeAssigneeModal(props) {
    const { id, dismissModal, onSuccess } = props;
    const { t: changeAssigneeModalTexts } = useLocaleKeys('pages.agreementsDashboard.changeAssigneeModal');
    const { api } = useStoreActions();
    const updateRelationship = useUpdateRelationship();
    const { loading, data, renderRestfulState } = useRestfulWrapper({
        fetch: ()=>Promise.all([
                api.member.getAll(),
                api.relationship.get(id)
            ])
    });
    const [sellerUserId, setSellerUserId] = useState('');
    async function changeAssignee() {
        if (!data) return;
        updateRelationship({
            id,
            version: data[1].version,
            changes: [
                agreementChangeModel.makeSellerChange(sellerUserId || relationshipModel.sellerID(data[1]))
            ],
            onSuccess: async ()=>{
                await onSuccess();
                dismissModal();
            }
        });
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'change_assignee_confirm'
            },
            secondaryButton: {
                name: 'change_assignee_cancel'
            }
        },
        title: changeAssigneeModalTexts.title(),
        testId: "change-assignee-modal",
        textAlignCenter: false,
        primaryButtonLabel: changeAssigneeModalTexts.save(),
        secondaryButtonLabel: changeAssigneeModalTexts.cancel(),
        primaryButtonDisabled: loading,
        onPrimaryButtonClick: changeAssignee,
        onSecondaryButtonClick: ()=>dismissModal(),
        content: renderRestfulState({
            renderChild: (param)=>{
                let { data } = param;
                return /*#__PURE__*/ _jsx(AssigneeField, {
                    members: data[0].members,
                    sellerUserId: sellerUserId || relationshipModel.sellerID(data[1]),
                    setSellerUserId: setSellerUserId
                });
            },
            renderLoader: ()=>/*#__PURE__*/ _jsx(TextField, {
                    bi: {
                        name: 'assignee_loading_placeholder'
                    },
                    collapseHelperText: false,
                    testId: "select-assignee-placeholder",
                    label: changeAssigneeModalTexts.assigneeLabel(),
                    value: changeAssigneeModalTexts.loading()
                })
        })
    });
}
